import React, { useEffect, useState } from 'react'
import {
  View,
  ScrollView
} from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { usepaycheckStore } from '../../../stores/paycheck'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import moment from 'moment'
import { useHomeStore } from '../../../stores/home'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import { ActivityIndicator } from 'react-native'
import Canvas from '../../canvas'
import { useLabourStore } from '../../../stores/labour'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'

const Directdepositonline = ({ navigation, route }: any) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    essUserOnBoardingFormKey,
    essUserOnBoardingKey
  } = params

  const paycheckstore = usepaycheckStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  const homestore = useHomeStore()
  const formsstore = useFormsStore()
   const labourstore = useLabourStore()

  useEffect(() => {
    paycheckstore.getDepositDetails(initializestore.initializeData.userkey)
    labourstore.fetchData(initializestore.initializeData.userkey)
    return () => {
      paycheckstore.clearData()
    }
  }, [])


  const information = paycheckstore.depositData?.data
  const [signatureDataURL, setSignatureDataURL] = useState('')
  const [hasDrawn, setHasDrawn] = useState(false);
  const { loading } = useFormsStore()
 

  const data = {
    essUserKey: initializestore.initializeData?.userkey,
    formKey: essUserOnBoardingFormKey,
    sign: signatureDataURL,
    completeOnline: true
  }

  const handlesubmit = async () => {

    // if (data?.formKey == null || data?.formKey == undefined) {
    //   await Toast.show({
    //     type: 'error',
    //     position: 'bottom',
    //     text1: 'Something went wrong. Please try again.',
    //     visibilityTime: 3000,
    //     autoHide: true,
    //     topOffset: 60,
    //   });
    //   return;
    // }
    const response = await formsstore.postdirectdepositonline(data)

    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    }
    else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel='UpdateDirectDeposit'
            navScreen='UpdateDirectDeposit'
            params={{
              essUserOnBoardingFormKey,
              essUserOnBoardingKey,
              mode: "online"
            }}
            title='Direct Deposit Form'
          />
        </View>
      </View>
      <View style={{ marginTop: -34, padding: 8 }}>
        <Card>
          <View>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                borderBottom: '5px double #000',
                marginTop: '-10px'
              }}
            >
              <tr>
                <td style={{ textAlign: 'center' }}>
                  <h5>Employee Direct Deposit Authorization Agreement</h5>
                </td>
              </tr>
            </table>
            <p
              style={{
                margin: '0px',
                fontSize: '10px',
                marginTop: '10px',
                marginBottom: '10px'
              }}
            >
              <b>Employee Number :</b> {labourstore?.labourData?.employeeNumber ? labourstore?.labourData?.employeeNumber : ""}
            </p>
            <div
              style={{ width: '100%', fontFamily: 'arial', fontSize: '10px' }}
            >


              <div style={{ marginBottom: '10px' }}>
                I hereby authorize my employer,<u><b>{homestore?.corporation?.data?.corporationName}</b></u>,
                (hereinafter COMPANY) to deposit any amounts owed me by
                initiating credit entries to my account at the financial
                institution (hereinafter BANK) indicated below. Further, I
                authorize BANK to accept and to credit any credit entries
                indicated by COMPANY to my account. In the event that COMPANY
                deposits funds erroneously into my account, I authorize COMPANY
                to debit my account for an amount not to exceed the original
                amount of the erroneous credit.
              </div>
              <h4 style={{ margin: '0px', marginBottom: '3px' }}>
                Employee Information
              </h4>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tr>
                  <td
                    style={{
                      width: '50%',
                      fontSize: '10px',
                      border: '1px solid #000',
                      padding: '5px'
                    }}
                  >
                    Employee Name
                    <br />
                    <span style={{ fontWeight: 'bold' }}>
                      {personalstore.personalData?.lastName} &nbsp; {personalstore.personalData?.middleInitial} &nbsp;
                      {personalstore.personalData?.firstName}
                    </span>
                  </td>
                  <td
                    style={{
                      width: '48%',
                      fontSize: '10px',
                      border: '1px solid #000',
                      padding: '5px'
                    }}
                  >
                    Social Security Number
                    <br />
                    <span style={{ fontWeight: 'bold' }}>
                      {personalstore.personalData?.ssn ? `XXX-XX-${personalstore.personalData?.ssnLastFour}` : ''}
                    </span>
                  </td>
                </tr>
              </table>
              {information?.map((item, index) => {
                return (
                  <table
                    key={index}
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      marginTop: '10px',
                      backgroundColor: '#f1f1f1'
                    }}
                  >
                    <tr>
                      <td
                        style={{
                          width: '30%',
                          fontSize: '10px',
                          border: '1px solid #000',
                          padding: '5px',
                          verticalAlign: 'top'
                        }}
                      >
                        Routing Number
                        <br />
                        <span style={{ fontWeight: 'bold' }}>
                          {item.routingNumber}
                        </span>
                        <br />
                        <br />
                        Account Number
                        <br />
                        <span style={{ fontWeight: 'bold' }}>
                          {item.accountNumber}
                        </span>
                      </td>
                      <td
                        style={{
                          width: '30%',
                          fontSize: '10px',
                          border: '1px solid #000',
                          padding: '5px',
                          verticalAlign: 'top'
                        }}
                      >
                        Account Type
                        <br />
                        <span style={{ fontWeight: 'bold' }}>
                          {item.accountType}
                        </span>
                        <br />
                        <br />
                        Amount
                        <br />
                        {index == 0 ? (
                          <span style={{ fontWeight: 'bold' }}>Net</span>
                        ) : (
                          <span style={{ fontWeight: 'bold' }}>
                            {item.amount}
                          </span>
                        )}
                      </td>
                      <td
                        style={{
                          width: '40%',
                          fontSize: '10px',
                          border: '1px solid #000',
                          padding: '5px'
                        }}
                      >
                        Financial Institution
                        <br />
                        <b style={{ display: 'inline-block', marginBottom: "10px" }}>{item.financialInstitution}</b>

                        {item.filePath && (
                          <img
                            src={`data:image/png;base64,${item.filePath}`}
                            width="100%"
                            height="300px"
                          />
                        )}
                      </td>
                    </tr>
                  </table>
                )
              })}

              <div>
                <p style={{ fontSize: '10px' }}>
                  This authorization is to remain in full force and effect until
                  COMPANY and BANK have received written notice from me of its
                  termination in such time and in such manner as to afford
                  COMPANY and BANK a reasonable opportunity to act on it.
                </p>
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginTop: '10px'
                  }}
                >
                  <tr>
                    <td
                      style={{
                        width: '50%',
                        fontSize: '10px',
                        border: '1px solid #000',
                        padding: '5px'
                      }}
                    >
                      Employee Signature
                      <br />
                      <span style={{ fontWeight: 'bold' }}>
                        <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} />
                      </span>
                    </td>
                    <td
                      style={{
                        width: '48%',
                        fontSize: '10px',
                        border: '1px solid #000',
                        padding: '5px'
                      }}
                    >
                      Date of Signature
                      <br />
                      <span style={{ fontWeight: 'bold' }}>
                        {moment().format('MM/DD/YYYY')}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            {loading ? <ActivityIndicator /> :

              <View
                style={{
                  marginTop: 10,
                  marginBottom: 25,
                  flexDirection: 'row',
                  justifyContent: 'space-between'
                }}
              >
                <CustomButton
                  text={'Previous'}
                  color={'warn'}
                  onPress={() =>
                    navigation.navigate('UpdateDirectDeposit', {
                      essUserOnBoardingFormKey,
                      essUserOnBoardingKey,
                      mode: 'online'
                    })
                  }
                />

                <CustomButton
                  isDisabled={!signatureDataURL || !hasDrawn}
                  text={'Submit'}
                  onPress={handlesubmit}
                />
              </View>}
          </View>
        </Card>
      </View>

    </ScrollView>
  )
}

export default Directdepositonline
